{
  "HELP_CENTER": {
    "TITLE": "Hjálparmiðstöð",
    "NEW_PAGE": {
      "DESCRIPTION": "Búðu til sjálfsafgreiðslugáttir í hjálparmiðstöð fyrir viðskiptavini þína. Hjálpaðu þeim að finna svör hratt, án þess að bíða. Straumlínulagaðu fyrirspurnir, auktu skilvirkni þjónustufulltrúa og bættu þjónustu við viðskiptavini.",
      "CREATE_PORTAL_BUTTON": "Búa til gátt"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Ónefnt"
    },
    "HEADER": {
      "FILTER": "Sía eftir",
      "SORT": "Raða eftir",
      "LOCALE": "Landstaðall",
      "SETTINGS_BUTTON": "Stillingar",
      "NEW_BUTTON": "Ný grein",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Útgefið",
        "DRAFT": "Draft",
        "ARCHIVED": "Í geymslu"
      },
      "TITLES": {
        "ALL_ARTICLES": "Allar greinar",
        "MINE": "Mínar greinar",
        "DRAFT": "Draft greinar",
        "ARCHIVED": "Greinar í geymslu"
      },
      "LOCALE_SELECT": {
        "TITLE": "Velja landstaðal",
        "PLACEHOLDER": "Velja landstaðal",
        "NO_RESULT": "Enginn landstaðall fannst",
        "SEARCH_PLACEHOLDER": "Leita að landstaðli"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Allar greinar",
      "PUBLISH_BUTTON": "Gefa út",
      "MOVE_TO_ARCHIVE_BUTTON": "Færa í geymslu",
      "PREVIEW": "Forskoða",
      "ADD_TRANSLATION": "Bæta við þýðingu",
      "OPEN_SIDEBAR": "Opna hliðarslá",
      "CLOSE_SIDEBAR": "Loka hliðarslá",
      "SAVING": "Vistar...",
      "SAVED": "Vistað"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Hlaða upp mynd",
        "UPLOADING": "Hleður upp...",
        "SUCCESS": "Mynd hlaðið upp",
        "ERROR": "Villa við að hlaða upp mynd",
        "UN_AUTHORIZED_ERROR": "Þú hefur ekki heimild til að hlaða upp myndum",
        "ERROR_FILE_SIZE": "Myndastærð ætti að vera minni en {size}MB",
        "ERROR_FILE_FORMAT": "Myndasnið ætti að vera jpg, jpeg eða png",
        "ERROR_FILE_DIMENSIONS": "Myndastærð ætti að vera minni en 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Setja inn akkeri",
        "TITLE": "Setja inn akkeri",
        "SUBMIT": "Setja inn",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Stillingar greinar",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Flokkur",
          "TITLE": "Velja flokk",
          "PLACEHOLDER": "Velja flokk",
          "NO_RESULT": "Enginn flokkur fannst",
          "SEARCH_PLACEHOLDER": "Leita að flokki"
        },
        "AUTHOR": {
          "LABEL": "Höfundur",
          "TITLE": "Velja höfund",
          "PLACEHOLDER": "Velja höfund",
          "NO_RESULT": "Enginn höfundur fannst",
          "SEARCH_PLACEHOLDER": "Leita að höfundi"
        },
        "META_TITLE": {
          "LABEL": "Meta titill",
          "PLACEHOLDER": "Bæta við meta titli"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta lýsing",
          "PLACEHOLDER": "Bættu við meta lýsingu til að fá betri niðurstöður í leitarvélarbestun..."
        },
        "META_TAGS": {
          "LABEL": "Meta tögg",
          "PLACEHOLDER": "Bættu við meta töggum aðskildum með kommu..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Geyma grein",
        "DELETE": "Eyða grein"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Óflokkað",
      "SEARCH_RESULTS": "Leitarniðurstöður fyrir {query}",
      "EMPTY_TEXT": "Leitaðu að greinum til að setja inn í svör.",
      "SEARCH_LOADER": "Leitar...",
      "INSERT_ARTICLE": "Setja inn",
      "NO_RESULT": "Engar greinar fundust",
      "COPY_LINK": "Afrita hlekk greinar á klippispjald",
      "OPEN_LINK": "Opna grein í nýjum flipa",
      "PREVIEW_LINK": "Forskoða grein"
    },
    "PORTAL": {
      "HEADER": "Gáttir",
      "DEFAULT": "Sjálfgefið",
      "NEW_BUTTON": "Ný gátt",
      "ACTIVE_BADGE": "virk",
      "CHOOSE_LOCALE_LABEL": "Veldu landstaðal",
      "LOADING_MESSAGE": "Hleður gáttum...",
      "ARTICLES_LABEL": "greinar",
      "NO_PORTALS_MESSAGE": "Engar gáttir eru tiltækar",
      "ADD_NEW_LOCALE": "Bæta við nýjum landstaðli",
      "POPOVER": {
        "TITLE": "Gáttir",
        "PORTAL_SETTINGS": "Stillingar gáttar",
        "SUBTITLE": "Þú ert með margar gáttir og getur haft mismunandi landastaðla fyrir hverja gátt.",
        "CANCEL_BUTTON_LABEL": "Hætta við",
        "CHOOSE_LOCALE_BUTTON": "Velja landstaðal"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "greinar",
            "ADD": "Bæta við landstaðli",
            "VISIT": "Skoða síðu",
            "SETTINGS": "Stillingar",
            "DELETE": "Eyða"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Stillingar gáttar",
            "ITEMS": {
              "NAME": "Nafn",
              "DOMAIN": "Sérsniðið lén",
              "SLUG": "Slug",
              "TITLE": "Titill gáttar",
              "THEME": "Þemalitur",
              "SUB_TEXT": "Undirtexti gáttar"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Tiltækir landstaðlar",
            "TABLE": {
              "NAME": "Heiti landstaðals",
              "CODE": "Kóði landstaðals",
              "ARTICLE_COUNT": "Fjöldi greina",
              "CATEGORIES": "Fjöldi flokka",
              "SWAP": "Skipta",
              "DELETE": "Eyða",
              "DEFAULT_LOCALE": "Sjálfgefið"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Eyða gátt",
          "MESSAGE": "Ertu viss um að þú viljir eyða þessari gátt",
          "YES": "Já, eyða gátt",
          "NO": "Nei, halda gátt",
          "API": {
            "DELETE_SUCCESS": "Gátt eytt",
            "DELETE_ERROR": "Villa við að eyða gátt"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Breyta gátt",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Grunnupplýsingar"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Sérsnið gáttar"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Flokkar"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Landstaðlar"
          }
        },
        "CATEGORIES": {
          "TITLE": "Flokkar í",
          "NEW_CATEGORY": "Nýr flokkur",
          "TABLE": {
            "NAME": "Nafn",
            "DESCRIPTION": "Lýsing",
            "LOCALE": "Landstaðall",
            "ARTICLE_COUNT": "Fjöldi greina",
            "ACTION_BUTTON": {
              "EDIT": "Breyta flokki",
              "DELETE": "Eyða flokki"
            },
            "EMPTY_TEXT": "Engir flokkar fundust"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Uppfæra grunnstillingar"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Upplýsingar um hjálparmiðstöð",
            "BODY": "Grunnupplýsingar um gátt"
          },
          "CUSTOMIZATION": {
            "TITLE": "Sérsnið hjálparmiðstöðvar",
            "BODY": "Sérsníða gátt"
          },
          "FINISH": {
            "TITLE": "Þetta er komið! 🎉",
            "BODY": "Allt klárt!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Til baka",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Búa til gátt",
            "TITLE": "Upplýsingar um hjálparmiðstöð",
            "CREATE_BASIC_SETTING_BUTTON": "Búa til grunnstillingar gáttar"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Sérsnið gáttar",
            "TITLE": "Sérsnið hjálparmiðstöðvar",
            "UPDATE_PORTAL_BUTTON": "Uppfæra stillingar gáttar"
          },
          "FINISH_PAGE": {
            "TITLE": "Þetta er komið! 🎉 Allt er tilbúið!",
            "MESSAGE": "Þú getur nú séð þessa stofnuðu gátt á síðunni þinni fyrir allar gáttir.",
            "FINISH": "Fara á síðu allra gátta"
          }
        },
        "LOGO": {
          "LABEL": "Merki",
          "UPLOAD_BUTTON": "Hlaða upp merki",
          "HELP_TEXT": "Þetta lógó mun birtast á haus gáttarinnar.",
          "IMAGE_UPLOAD_SUCCESS": "Merki hlaðið upp",
          "IMAGE_UPLOAD_ERROR": "Merki eytt",
          "IMAGE_DELETE_ERROR": "Villa við að eyða merki"
        },
        "NAME": {
          "LABEL": "Nafn",
          "PLACEHOLDER": "Nafn gáttar",
          "HELP_TEXT": "Nafnið verður notað í almannagáttinni innbyrðis.",
          "ERROR": "Nafn er nauðsynlegt"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug fyrir gátt (fyrir vefslóðir)",
          "ERROR": "Slug er nauðsynlegt"
        },
        "DOMAIN": {
          "LABEL": "Sérsniðið lén",
          "PLACEHOLDER": "Sérsniðið lén gáttar",
          "HELP_TEXT": "Bættu aðeins við ef þú vilt nota sérsniðið lén fyrir gáttirnar þínar. Dæmi: {exampleURL}",
          "ERROR": "Sláðu inn gilda lénsslóð"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Hlekkur á heimasíðu",
          "PLACEHOLDER": "Hlekkur á heimasíðu gáttar",
          "HELP_TEXT": "Hlekkurinn sem er notaður til að fara af gáttinni aftur á heimasíðuna. Dæmi: {exampleURL}",
          "ERROR": "Sláðu inn gilda vefslóð fyrir heimasíðu"
        },
        "THEME_COLOR": {
          "LABEL": "Þemalitur gáttar",
          "HELP_TEXT": "Þessi litur mun birtast sem þemalitur gáttarinnar."
        },
        "PAGE_TITLE": {
          "LABEL": "Titill síðu",
          "PLACEHOLDER": "Titill síðu gáttar",
          "HELP_TEXT": "Titill síðunnar verður notaður í gáttinni sem snýr að almenningi.",
          "ERROR": "Titill síðu er nauðsynlegur"
        },
        "HEADER_TEXT": {
          "LABEL": "Texti í haus",
          "PLACEHOLDER": "Texti í haus gáttar",
          "HELP_TEXT": "Texti gáttarhaussins verður notaður í gáttinni sem snýr að almenningi.",
          "ERROR": "Texti í haus gáttar er nauðsynlegur"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Gátt búin til.",
          "ERROR_MESSAGE_FOR_BASIC": "Ekki tókst að búa til gátt. Reyndu aftur.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Gátt uppfærð.",
          "ERROR_MESSAGE_FOR_UPDATE": "Ekki tókst að uppfæra gátt. Reyndu aftur."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Bæta við nýjum landstaðli",
        "SUB_TITLE": "Þetta bætir nýjum landstaðli við tiltæka þýðingarlistann þinn.",
        "PORTAL": "Gátt",
        "LOCALE": {
          "LABEL": "Landstaðall",
          "PLACEHOLDER": "Veldu landstaðal",
          "ERROR": "Landstaðall er nauðsynlegur"
        },
        "BUTTONS": {
          "CREATE": "Búa til landstaðal",
          "CANCEL": "Hætta við"
        },
        "API": {
          "SUCCESS_MESSAGE": "Landstaðli bætt við",
          "ERROR_MESSAGE": "Ekki tókst að bæta við landstaðli. Reyndu aftur."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Sjálfgefinn landstaðall uppfærður",
          "ERROR_MESSAGE": "Ekki er hægt að uppfæra sjálfgefna landstaðal. Reyndu aftur."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Landstaðli var fjarlægt úr gátt",
          "ERROR_MESSAGE": "Ekki tókst að fjarlægja landstaðli úr gáttinni. Reyndu aftur."
        }
      }
    },
    "TABLE": {
      "404": "Engar greinar samsvara leitinni þinni 🔍",
      "LOADING_MESSAGE": "Hleður greinum...",
      "NO_ARTICLES": "Engar greinar eru tiltækar",
      "HEADERS": {
        "TITLE": "Titill",
        "CATEGORY": "Flokkur",
        "READ_COUNT": "Skoðanir",
        "STATUS": "Staða",
        "LAST_EDITED": "Síðast breytt"
      },
      "COLUMNS": {
        "BY": "eftir",
        "AUTHOR_NOT_AVAILABLE": "Höfundur ekki tiltækur"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Hleður grein...",
      "TITLE_PLACEHOLDER": "Titill greinar kemur hér",
      "CONTENT_PLACEHOLDER": "Skrifaðu grein þína hér",
      "API": {
        "ERROR": "Villa við að vista grein"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Villa við að gefa út grein",
        "SUCCESS": "Grein gefin út"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Villa við að setja grein í geymslu",
        "SUCCESS": "Grein sett í geymslu"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Villa við að vista grein sem Draft",
        "SUCCESS": "Grein vistuð sem Draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Staðfesta eyðingu",
          "MESSAGE": "Ertu viss um að þú viljir eyða greininni?",
          "YES": "Já, eyða",
          "NO": "Nei, halda henni"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Grein eytt",
        "ERROR_MESSAGE": "Villa við að eyða grein"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Vinsamlegast bættu við fyrirsögn greinarinnar og innihaldi þá er aðeins þú sem getur uppfært stillingarnar"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Leita að greinum"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Búa til flokk",
        "SUB_TITLE": "Flokkurinn verður notað í gáttinni sem snýr að almenningi til að flokka greinar.",
        "PORTAL": "Gátt",
        "LOCALE": "Landstaðall",
        "NAME": {
          "LABEL": "Nafn",
          "PLACEHOLDER": "Heiti flokks",
          "HELP_TEXT": "Heiti og táknmynd flokksins verða notuð í almannagáttinni til að flokka greinar.",
          "ERROR": "Nafn er nauðsynlegt"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug fyrir flokk (fyrir vefslóðir)",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/slodin-min",
          "ERROR": "Slug er nauðsynlegt"
        },
        "DESCRIPTION": {
          "LABEL": "Lýsing",
          "PLACEHOLDER": "Gefðu stutta lýsingu á flokknum.",
          "ERROR": "Lýsing er nauðsynleg"
        },
        "BUTTONS": {
          "CREATE": "Búa til flokk",
          "CANCEL": "Hætta við"
        },
        "API": {
          "SUCCESS_MESSAGE": "Flokkur búinn til",
          "ERROR_MESSAGE": "Ekki tókst að búa til flokk"
        }
      },
      "EDIT": {
        "TITLE": "Breyta flokki",
        "SUB_TITLE": "Breyting á flokki mun uppfæra flokkinn í opinberu gáttinni.",
        "PORTAL": "Gátt",
        "LOCALE": "Landstaðall",
        "NAME": {
          "LABEL": "Nafn",
          "PLACEHOLDER": "Heiti flokks",
          "HELP_TEXT": "Heiti og táknmynd flokksins verða notuð í almannagáttinni til að flokka greinar.",
          "ERROR": "Nafn er nauðsynlegt"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug fyrir flokk (fyrir vefslóðir)",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/slodin-min",
          "ERROR": "Slug er nauðsynlegt"
        },
        "DESCRIPTION": {
          "LABEL": "Lýsing",
          "PLACEHOLDER": "Gefðu stutta lýsingu á flokknum.",
          "ERROR": "Lýsing er nauðsynleg"
        },
        "BUTTONS": {
          "CREATE": "Uppfæra flokk",
          "CANCEL": "Hætta við"
        },
        "API": {
          "SUCCESS_MESSAGE": "Flokkur uppfærður",
          "ERROR_MESSAGE": "Ekki tókst að uppfæra flokk"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Flokki eytt",
          "ERROR_MESSAGE": "Ekki tókst að eyða flokki"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Leita að greinum",
      "PLACEHOLDER": "Leita að greinum",
      "NO_RESULT": "Engar greinar fundust",
      "SEARCHING": "Leitar...",
      "SEARCH_BUTTON": "Leit",
      "INSERT_ARTICLE": "Setja inn hlekk",
      "IFRAME_ERROR": "Vefslóð er tóm eða ógild. Ekki er hægt að birta efni.",
      "OPEN_ARTICLE_SEARCH": "Setja inn grein úr hjálparmiðstöð",
      "SUCCESS_ARTICLE_INSERTED": "Grein sett inn",
      "PREVIEW_LINK": "Forskoða grein",
      "CANCEL": "Loka",
      "BACK": "Til baka",
      "BACK_RESULTS": "Til baka í niðurstöður"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Hjálparmiðstöð",
      "DESCRIPTION": "Búðu til notendavænar sjálfsafgreiðslugáttir. Hjálpaðu notendum þínum að nálgast greinar og fá aðstoð allan sólarhringinn. Uppfærðu áskriftina þína til að virkja þennan eiginleika.",
      "SELF_HOSTED_DESCRIPTION": "Búðu til notendavænar sjálfsafgreiðslugáttir. Hjálpaðu notendum þínum að nálgast greinar og fá aðstoð allan sólarhringinn. Hafðu samband við kerfisstjóra þinn til að virkja þennan eiginleika.",
      "BUTTON": {
        "LEARN_MORE": "Læra meira",
        "UPGRADE": "Uppfæra"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Margar gáttir",
          "DESCRIPTION": "Búðu til margar hjálparmiðstöðvargáttir fyrir mismunandi vörur með sama aðgangi."
        },
        "LOCALES": {
          "TITLE": "Full stuðningur við landstaðla",
          "DESCRIPTION": "Staðfærðu gáttina á þínu tungumáli. Við styðjum alla landstaðla og leyfum þýðingar fyrir hverja grein."
        },
        "SEO": {
          "TITLE": "SEO-vænt útlit",
          "DESCRIPTION": "Sérsníddu meta töggin þín til að bæta sýnileika á leitarvélum með SEO-vænum síðum okkar."
        },
        "API": {
          "TITLE": "Fullur stuðningur við API",
          "DESCRIPTION": "Notaðu gáttina sem hausslaust CMS með framendaumgjörðum þriðja aðila með API-um okkar."
        }
      }
    },
    "LOADING": "Hleður...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} skoðun | {count} skoðanir",
          "DROPDOWN_MENU": {
            "PUBLISH": "Gefa út",
            "DRAFT": "Draft",
            "ARCHIVE": "Geyma",
            "DELETE": "Eyða"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Útgefið",
            "ARCHIVED": "Í geymslu"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Óflokkað"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Allar greinar",
          "MINE": "Mitt",
          "DRAFT": "Draft",
          "PUBLISHED": "Útgefið",
          "ARCHIVED": "Í geymslu"
        },
        "CATEGORY": {
          "ALL": "Allir flokkar"
        },
        "LOCALE": {
          "ALL": "Allir landstaðlar"
        },
        "NEW_ARTICLE": "Ný grein"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Skrifa grein",
          "SUBTITLE": "Skrifaðu ítarlega grein, byrjum!",
          "BUTTON_LABEL": "Ný grein"
        },
        "MINE": {
          "TITLE": "Þú hefur ekki skrifað neinar greinar hér",
          "SUBTITLE": "Allar greinar sem þú hefur skrifað birtast hér fyrir fljótan aðgang."
        },
        "DRAFT": {
          "TITLE": "Engar greinar eru í Draft",
          "SUBTITLE": "Draft greinar munu birtast hér"
        },
        "PUBLISHED": {
          "TITLE": "Engar útgefnar greinar eru til",
          "SUBTITLE": "Útgefnar greinar munu birtast hér"
        },
        "ARCHIVED": {
          "TITLE": "Engar greinar eru í geymslunni",
          "SUBTITLE": "Greinar í geymslu birtast ekki á gáttinni, þú getur notað þær til að merkja úreltar síður"
        },
        "CATEGORY": {
          "TITLE": "Engar greinar eru í þessum flokki",
          "SUBTITLE": "Greinar í þessum flokki munu birtast hér"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nýr flokkur",
        "EDIT_CATEGORY": "Breyta flokki",
        "CATEGORIES_COUNT": "{n} flokkur | {n} flokkar",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Flokkar ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} greinar) | {categoryName} ({categoryCount} grein)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Engir flokkar fundust",
        "SUBTITLE": "Flokkar munu birtast hér. Þú getur bætt við flokki með því að smella á hnappinn 'Nýr flokkur'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} grein | {count} greinar",
        "EXPAND": "Sýna undirflokka",
        "COLLAPSE": "Fela undirflokka",
        "MENU": {
          "NEW_ARTICLE": "Ný grein",
          "ADD_SUBCATEGORY": "Bæta við undirflokki",
          "EDIT": "Breyta",
          "DELETE": "Eyða"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Flokkur búinn til",
            "ERROR_MESSAGE": "Ekki tókst að búa til flokk"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Flokkur uppfærður",
            "ERROR_MESSAGE": "Ekki tókst að uppfæra flokk"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Flokki eytt",
            "ERROR_MESSAGE": "Ekki tókst að eyða flokki"
          },
          "CONFIRM": {
            "TITLE": "Eyða flokki",
            "DESCRIPTION": "Ertu viss um að þú viljir eyða þessum flokki? Greinar hans verða óflokkaðar.",
            "DESCRIPTION_WITH_CHILDREN": "Ertu viss um að þú viljir eyða þessum flokki? Greinar hans verða óflokkaðar og {count} undirflokkur hans verður færður á efsta stig. | Ertu viss um að þú viljir eyða þessum flokki? Greinar hans verða óflokkaðar og {count} undirflokkar hans verða færðir á efsta stig.",
            "CONFIRM": "Eyða"
          }
        },
        "HEADER": {
          "CREATE": "Búa til flokk",
          "EDIT": "Breyta flokki",
          "DESCRIPTION": "Breyting á flokki mun uppfæra flokkinn í opinberu gáttinni.",
          "PORTAL": "Gátt",
          "LOCALE": "Landstaðall"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Nafn",
            "PLACEHOLDER": "Heiti flokks",
            "ERROR": "Nafn er nauðsynlegt"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug fyrir flokk (fyrir vefslóðir)",
            "ERROR": "Slug er nauðsynlegt",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Lýsing",
            "PLACEHOLDER": "Gefðu stutta lýsingu á flokknum.",
            "ERROR": "Lýsing er nauðsynleg"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Yfirflokkur",
            "PLACEHOLDER": "Veldu yfirflokk",
            "NONE": "Enginn (efsta stig)"
          }
        },
        "BUTTONS": {
          "CREATE": "Stofna",
          "EDIT": "Uppfæra",
          "CANCEL": "Hætta við"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Engir landstaðlar tiltækir | {n} landstaðall | {n} landstaðlar",
      "NEW_LOCALE_BUTTON_TEXT": "Nýr landstaðall",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} grein | {count} greinar",
        "CATEGORIES_COUNT": "{count} flokkur | {count} flokkar",
        "DEFAULT": "Sjálfgefið",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Gera að sjálfgefnu",
          "DELETE": "Eyða"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Bæta við nýjum landstaðli",
        "DESCRIPTION": "Veldu tungumálið sem þessi grein verður skrifuð á. Þessu verður bætt við þýðingalistann þinn og þú getur bætt fleiri við síðar.",
        "COMBOBOX": {
          "PLACEHOLDER": "Velja landstaðal..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Landstaðli bætt við",
          "ERROR_MESSAGE": "Ekki tókst að bæta við landstaðli. Reyndu aftur."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Vistar...",
          "SAVED": "Vistað"
        },
        "PREVIEW": "Forskoða",
        "PUBLISH": "Gefa út",
        "DRAFT": "Draft",
        "ARCHIVE": "Geyma",
        "BACK_TO_ARTICLES": "Til baka í greinar"
      },
      "DRAFT": {
        "PENDING_LABEL": "Óbirtar breytingar",
        "PROMOTE": "Birta breytingar",
        "DISCARD": "Henda breytingum",
        "PROMOTE_SUCCESS": "Draft-breytingar birtar í virku greininni",
        "PROMOTE_ERROR": "Ekki tókst að birta Draft-breytingarnar",
        "DISCARD_SUCCESS": "Draft-breytingum hent",
        "DISCARD_ERROR": "Ekki tókst að henda Draft-breytingunum"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Útgáfusaga",
        "TITLE": "Útgáfusaga",
        "BACK": "Til baka í grein",
        "LOADING": "Hleður útgáfum...",
        "EMPTY": "Engar útgáfur ennþá. Breytingar á þessari grein birtast hér.",
        "EMPTY_CONTENT": "Þessi útgáfa hefur ekkert efni.",
        "CURRENT_BADGE": "Núverandi",
        "RESTORED_BADGE": "Endurheimt",
        "AUTOMATED_USER": "Sjálfvirk uppfærsla",
        "RESTORE": "Endurheimta þessa útgáfu",
        "RESTORE_DIALOG": {
          "TITLE": "Endurheimta þessa útgáfu?",
          "DESCRIPTION": "Greinin fer aftur í orðalag þessarar útgáfu. Ekkert tapast — núverandi texti er áfram í sögunni, og ef greinin er þegar útgefin heldur opinbera síðan áfram að sýna virku útgáfuna þar til þú birtir þessa breytingu.",
          "CONFIRM": "Endurheimta"
        },
        "RESTORE_SUCCESS": "Útgáfa endurheimt",
        "RESTORE_ERROR": "Ekki tókst að endurheimta þessa útgáfu",
        "FETCH_ERROR": "Ekki tókst að hlaða útgáfusögunni"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Fleiri eiginleikar",
        "TRANSLATE": "Þýða",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Óflokkað",
        "EDITOR_PLACEHOLDER": "Skrifaðu eitthvað...",
        "HTML_EMBED": {
          "TITLE": "Setja inn sérsniðið HTML",
          "DESCRIPTION": "Límdu hrátt HTML eins og iframe, embed eða widget-bút. Það birtist eins og það er í birtu greininni.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Setja inn"
        },
        "PRIMARY_CATEGORY": "Aðalflokkur"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Eiginleikar greinar",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Meta lýsing",
        "META_DESCRIPTION_PLACEHOLDER": "Bæta við meta lýsingu",
        "META_TITLE": "Meta titill",
        "META_TITLE_PLACEHOLDER": "Bæta við meta titli",
        "META_TAGS": "Meta tögg",
        "META_TAGS_PLACEHOLDER": "Bæta við meta töggum",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Tungumálaútgáfur",
        "LANGUAGE_MUTATIONS_EMPTY": "Engar tengdar greinar enn",
        "ADD_MUTATION": "Bæta við",
        "REMOVE_MUTATION": "Fjarlægja"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Tengja tungumálaútgáfur",
        "SEARCH_PLACEHOLDER": "Leita að greinum eftir titli",
        "EMPTY": "Engar samsvarandi greinar",
        "CANCEL": "Hætta við",
        "ADD_SELECTED": "Bæta við völdum",
        "SUCCESS": "Útgáfur uppfærðar",
        "ERROR": "Ekki tókst að uppfæra útgáfur"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Þýða grein",
        "DESCRIPTION": "Veldu tungumálin sem þú vilt þýða þessa grein á. Tungumál sem þegar hafa verið þýdd verða endurþýdd í Draft til yfirferðar.",
        "EMPTY": "Engin önnur tungumál eru í boði.",
        "CONNECTED_BADGE": "Þýtt",
        "CANCEL": "Hætta við",
        "TRANSLATE": "Þýða",
        "SUCCESS": "Þýðing hefst innan skamms. Þýddu greinarnar birtast fljótlega sem tungumálaútgáfur.",
        "ERROR": "Ekki tókst að hefja þýðingu"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Villa við að vista grein"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Ný gátt",
      "PORTALS": "Gáttir",
      "CREATE_PORTAL": "Búa til og stjórna mörgum gáttum",
      "ARTICLES": "greinar",
      "DOMAIN": "lén",
      "PORTAL_NAME": "Nafn gáttar"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Búa til nýja gátt",
      "DESCRIPTION": "Gefðu gáttinni þinni nafn og búðu til notendavænt slug fyrir vefslóð. Þú getur breytt hvoru tveggja síðar í stillingum.",
      "CONFIRM_BUTTON_LABEL": "Stofna",
      "NAME": {
        "LABEL": "Nafn",
        "PLACEHOLDER": "Notendahandbók",
        "MESSAGE": "Veldu nafn fyrir gáttina þína.",
        "ERROR": "Nafn er nauðsynlegt"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug er nauðsynlegt",
        "FORMAT_ERROR": "Notaðu aðeins bókstafi, tölustafi og bandstrik, til dæmis: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Merki",
          "IMAGE_UPLOAD_ERROR": "Ekki tókst að hlaða upp mynd! Reyndu aftur",
          "IMAGE_UPLOAD_SUCCESS": "Mynd bætt við. Smelltu á vista breytingar til að vista merkið",
          "IMAGE_DELETE_SUCCESS": "Merki eytt",
          "IMAGE_DELETE_ERROR": "Ekki tókst að eyða merki",
          "IMAGE_UPLOAD_SIZE_ERROR": "Myndastærð ætti að vera minni en {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Nafn",
          "PLACEHOLDER": "Nafn gáttar",
          "ERROR": "Nafn er nauðsynlegt"
        },
        "HEADER_TEXT": {
          "LABEL": "Texti í haus",
          "PLACEHOLDER": "Texti í haus gáttar"
        },
        "PAGE_TITLE": {
          "LABEL": "Titill síðu",
          "PLACEHOLDER": "Titill síðu gáttar"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Hlekkur á heimasíðu",
          "PLACEHOLDER": "Hlekkur á heimasíðu gáttar",
          "ERROR": "Ógild vefslóð. Hlekkur á heimasíðu verður að byrja á 'http://' eða 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug gáttar"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Beinn spjallgluggi",
          "PLACEHOLDER": "Velja beinan spjallglugga",
          "HELP_TEXT": "Veldu beinan spjallglugga sem birtist í hjálparmiðstöðinni þinni"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Aðgengilegt öllum",
          "HELP_TEXT": "Gerðu gáttina aðgengilega öllum sem hafa hlekkinn.",
          "OPTIONS": {
            "PUBLIC": "Já",
            "PRIVATE": "Nei"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Áfangi tengils",
          "HELP_TEXT": "Veldu hvort tenglar innan greina opnist í núverandi glugga eða nýjum.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Núverandi gluggi",
            "NEW_WINDOW": "Nýr gluggi"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Sjálfgefin myndastærð",
          "HELP_TEXT": "Stærðin sem er notuð á allar myndir sem þú setur inn í grein. Veldu Original til að setja inn myndir í upprunalegri stærð og veldu þess í stað stærð fyrir hverja mynd."
        },
        "BRAND_COLOR": {
          "LABEL": "Vörumerkjalitur"
        },
        "CUSTOM_HTML": {
          "LABEL": "Sérsniðið HTML",
          "PLACEHOLDER": "<!-- Límdu greiningar- eða mælingarkóðann þinn hér -->",
          "HELP_TEXT": "Sett inn í upphafi <body> merkisins á hverri síðu í hjálparmiðstöðinni. Notaðu það fyrir Google Analytics, Google Tag Manager eða annan mælingarkóða. Kóðinn birtist nákvæmlega eins og hann var sleginn inn og er ekki staðfestur."
        },
        "SAVE_CHANGES": "Vista breytingar"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Sérsniðið lén",
          "LABEL": "Sérsniðið lén:",
          "DESCRIPTION": "Þú getur hýst gáttina þína á sérsniðnu léni. Til dæmis, ef vefsíðan þín er yourdomain.com og þú vilt að gáttin sé aðgengileg á docs.yourdomain.com, sláðu það einfaldlega inn í þennan reit.",
          "PLACEHOLDER": "Sérsniðið lén gáttar",
          "EDIT_BUTTON": "Breyta sérsniðnu léni",
          "ADD_BUTTON": "Bæta við sérsniðnu léni",
          "DIALOG": {
            "ADD_HEADER": "Bæta við sérsniðnu léni",
            "EDIT_HEADER": "Breyta sérsniðnu léni",
            "ADD_CONFIRM_BUTTON_LABEL": "Bæta við léni",
            "EDIT_CONFIRM_BUTTON_LABEL": "Uppfæra lén",
            "LABEL": "Sérsniðið lén",
            "PLACEHOLDER": "Sérsniðið lén gáttar",
            "ERROR": "Sérsniðið lén er nauðsynlegt"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS stillingar",
            "DESCRIPTION": "Skráðu þig inn á reikninginn þinn hjá DNS-þjónustuveitunni og bættu við CNAME-færslunni hér að neðan fyrir undirlénið þitt.",
            "HELP_TEXT": "Þegar því er lokið getur þú haft samband við þjónustuborðið okkar til að óska eftir sjálfvirkt búnu SSL-skírteini.",
            "CONFIRM_BUTTON_LABEL": "Skil!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Eyða {portalName}",
          "HEADER": "Eyða gátt",
          "DESCRIPTION": "Eyða þessari gátt varanlega. Þessa aðgerð er ekki hægt að afturkalla",
          "DIALOG": {
            "HEADER": "Ertu viss um að þú viljir eyða {portalName}?",
            "DESCRIPTION": "Þetta er varanleg aðgerð sem ekki er hægt að afturkalla.",
            "CONFIRM_BUTTON_LABEL": "Eyða"
          }
        },
        "EDIT_CONFIGURATION": "Breyta stillingum"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Gátt búin til",
          "ERROR_MESSAGE": "Ekki tókst að búa til gátt"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Gátt uppfærð",
          "ERROR_MESSAGE": "Ekki tókst að uppfæra gátt"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Viðhengi",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Bæta við skrá",
      "DROP_HERE": "Draga og sleppa skrám hér",
      "COPY_LINK": "Afrita hlekk",
      "LINK_COPIED": "Hlekkur afritaður á klippispjald",
      "COPY_FAILED": "Ekki tókst að afrita hlekk",
      "DELETE": "Eyða",
      "CANCEL": "Hætta við",
      "QUEUED": "Í biðröð",
      "UPLOADING": "Hleður upp",
      "UPLOAD_FAILED": "Ekki tókst að hlaða upp skrá",
      "FILE_TOO_LARGE": "Skráin fer yfir 40 MB stærðarmörkin"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Þýðingarorðabók",
        "DESCRIPTION": "Hugtök sem eru skilgreind hér bætast við AI-þýðingarleiðbeiningarnar svo þau eru alltaf þýdd á sama hátt. Lykilhugtakið er skrifað á {locale}."
      },
      "NEW_TERM": "Nýtt hugtak",
      "EMPTY_STATE": {
        "TITLE": "Engin hugtök í orðabókinni enn",
        "SUBTITLE": "Bættu við hugtaki og þýðingu þess fyrir hvert tungumál. Þegar grein er þýdd eru þessi hugtök notuð til að tryggja að orðanotkun vörunnar haldist samræmd."
      },
      "LIST": {
        "TERM": "Hugtak",
        "TRANSLATIONS": "Þýðingar",
        "ACTIONS": "Aðgerðir"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Bæta við hugtaki",
          "EDIT": "Breyta hugtaki",
          "DESCRIPTION": "Hugtakið hér að neðan er notað til að tryggja samræmi við AI-þýðingu greina í hjálparmiðstöðinni þinni.",
          "PORTAL": "Gátt",
          "PRIMARY_LANGUAGE": "Aðaltungumál"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Hugtak ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Hugtak er nauðsynlegt"
          },
          "DESCRIPTION": {
            "LABEL": "Samhengi / athugasemdir (valfrjálst)",
            "PLACEHOLDER": "Hvenær og hvernig þetta hugtak er notað, til að hjálpa þýðandanum að greina á milli merkinga."
          },
          "TRANSLATIONS": "Þýðingar",
          "TRANSLATION_PLACEHOLDER": "Skildu eftir autt til að leyfa AI að þýða frjálst",
          "AUTO_TRANSLATE": {
            "BUTTON": "Þýða allt sjálfkrafa",
            "CONFIRM": "Þýða á {count} tungumál með AI?",
            "CONFIRM_BUTTON": "Þýða",
            "CANCEL": "Hætta við",
            "SUCCESS": "Þýðingar tilbúnar — yfirfarðu og vistaðu",
            "ERROR": "Ekki tókst að þýða sjálfkrafa. Reyndu aftur."
          }
        },
        "BUTTONS": {
          "CREATE": "Bæta við hugtaki",
          "EDIT": "Vista",
          "CANCEL": "Hætta við"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Hugtaki bætt við",
            "ERROR_MESSAGE": "Ekki tókst að bæta við hugtaki. Reyndu aftur."
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Hugtak uppfært",
            "ERROR_MESSAGE": "Ekki tókst að uppfæra hugtak. Reyndu aftur."
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Eyða hugtaki",
          "DESCRIPTION": "Ertu viss um að þú viljir eyða þessu hugtaki? Það verður ekki lengur notað við þýðingar.",
          "CONFIRM": "Eyða"
        },
        "API": {
          "SUCCESS_MESSAGE": "Hugtaki eytt",
          "ERROR_MESSAGE": "Ekki tókst að eyða hugtaki. Reyndu aftur."
        }
      }
    }
  }
}
